// Simple frontend-only auth (localStorage). Church admin gate.
const AUTH_KEY = 'gcbc_auth_v1';

// Default seed credentials — church admins can change/extend later
const SEED_USERS = [
  { username: 'admin', password: 'gcbc2026', name: 'Church Admin' },
  { username: 'treasurer', password: 'gcbc2026', name: 'Treasurer' },
];

export function login(username, password) {
  const user = SEED_USERS.find(
    (u) => u.username.toLowerCase() === (username || '').toLowerCase() && u.password === password,
  );
  if (!user) return { ok: false, error: 'Invalid username or password' };
  const session = { username: user.username, name: user.name, loggedInAt: new Date().toISOString() };
  localStorage.setItem(AUTH_KEY, JSON.stringify(session));
  return { ok: true, user: session };
}

export function logout() {
  localStorage.removeItem(AUTH_KEY);
}

export function currentUser() {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isAuthenticated() {
  return !!currentUser();
}
